import { render, staticRenderFns } from "./tableLink.vue?vue&type=template&id=daa75424&scoped=true&"
import script from "./tableLink.vue?vue&type=script&lang=js&"
export * from "./tableLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa75424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daa75424')) {
      api.createRecord('daa75424', component.options)
    } else {
      api.reload('daa75424', component.options)
    }
    module.hot.accept("./tableLink.vue?vue&type=template&id=daa75424&scoped=true&", function () {
      api.rerender('daa75424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempTable/components/tableLink.vue"
export default component.exports